<div class="membership text-center">
  <app-diploma-upload
    *ngIf="user && (user.specialty_category == 'physician' || user.specialty_category == 'non physician')"></app-diploma-upload>
</div>
